import React, {ChangeEvent} from 'react';

interface IMultipleReverceCheckbox extends React.HTMLProps<HTMLInputElement> {
  title?: string;
  id?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

const CustomRverceMultiCheckbox = ({
  title,
  id,
  onChange,
  ...props
}: IMultipleReverceCheckbox) => {
  return (
    <label className="flex items-center">
      <input {...props} type="checkbox" onChange={onChange} />
      <span className="text-sm mr-2">{title}</span>
    </label>
  );
};

export default CustomRverceMultiCheckbox;
